export default "__VITE_ASSET__0bdc1f83__"